import Vue from 'vue';
import axios from 'axios';
import Vuex from 'vuex';
{
  {
    /* eslint-disable */
  }
}
Vue.use(Vuex);
export default {
  state: {
    accomo: [],
    AddAccomo: [],
    UpdateAccomo: [],
    accomobyId: [],
    deleteAccomo: []
  },
  getters: {
    GetAllAccomo(state) {
      return state.accomo;
    },
    AddAllAccomo(state) {
      return state.AddAccomo;
    },
    UpdateAccomoRec(state) {
      return state.UpdateAccomo;
    },
    GetAccomById(state) {
      return state.accomobyId;
    },
    DeleteAccomodation(state) {
      return state.deleteAccomo;
    }
  },
  actions: {
    async getAccomodation({ commit }) {
      // .get(`${process.env.VUE_APP_API_URL}api/User/GetUsers`, {
      //return await axios.get('https://localhost:44395/api/InstructionalAccommodations').then((res) => {
      return await axios.get(`${process.env.VUE_APP_API_URL}/InstructionalAccommodations`).then((res) => {
        commit('Allaccomo', res.data.data);
        return res.data.data;
      });
    },
    async getAccomodationbyId({ commit }, Id) {
      //return await axios.get(`https://localhost:44395/api/InstructionalAccommodations/${Id}`, Id).then((res) => {
      return await axios.get(`${process.env.VUE_APP_API_URL}/InstructionalAccommodations/${Id}`, Id).then((res) => {
        commit('GetaccomoById', res.data.data);
        return res.data.data;
      });
    },
    async DeleteAccomodationbyId({ commit }, Id) {
      //return await axios.delete(`https://localhost:44395/api/InstructionalAccommodations/${Id}`);
      return await axios.delete(`${process.env.VUE_APP_API_URL}/InstructionalAccommodations/${Id}`);
    },
    async UpdateAccomodationbyId({ commit }, payload) {
      return await axios
        //.put('https://localhost:44395/api/InstructionalAccommodations', payload, {
        .put(`${process.env.VUE_APP_API_URL}/InstructionalAccommodations`, payload, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          if (response.status) {
            commit('Updateaccomorecord', payload.data.data);
          }
          return response;
        })
        .catch(function (error) {});
    },
    async addAccomodation({ commit }, payload) {
      // eslint-disable-line no-debugger
      return await axios
        //.post('https://localhost:44395/api/InstructionalAccommodations', payload, {
        .post(`${process.env.VUE_APP_API_URL}/InstructionalAccommodations`, payload, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function (response) {
          // debugger;
          // if (response.data.status == true) {
          //   // commit('Addaccomorecord', payload.data.data);
          // }
          return response;
        })
        .catch(function (error) {});
    }
  },

  mutations: {
    Addaccomorecord(state, payload) {
      state.AddAccomo = payload;
    },
    Allaccomo(state, payload) {
      state.accomo = payload;
    },
    GetaccomoById(state, payload) {
      state.accomobyId = payload;
    },
    Updateaccomorecord(state, payload) {
      state.UpdateAccomo = payload;
    },
    DeleteAccomodation(state, payload) {
      state.deleteAccomo = payload;
    }
  }
};
